import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { MemoryRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../../components/Login";
import ProtectedRoute from "../../components/ProtectedRoute";
import { SharePricePerformancePanels } from "@/components/SharePricePerformancePanels";
import useState from "react-usestateref";
import "../../styles/globals.css";

const useStyles = makeStyles({
  root: {
    "& .ant-collapse-header": {
      display: "none !important",
    },
  },
});

const App: React.FC = () => {
  window.history.replaceState(null, "", window.location.pathname);
  const styles = useStyles();
  const [isFirstStep, setIsFirstStep] = useState(false);
  return (
    <div className={isFirstStep && styles.root} style={{ minHeight: "100vh" }}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute
                authenticatedElement={<SharePricePerformancePanels setIsFirstStep={setIsFirstStep} />}
                isPopup={true}
                isFirstStep={isFirstStep}
              />
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
